import { __decorate, __metadata } from "tslib";
import { IsUndefinable } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsDate, IsEnum, IsNumber } from 'class-validator';
import { CartExposeGroup } from '../../cart/interface';
import { OrderSchedulingTypeEnum } from '../enum';
import { OrderExposeGroup } from '../interface';
export class PatchSchedulingInfoDto {
}
__decorate([
    ApiPropertyOptional({ enum: OrderSchedulingTypeEnum, example: OrderSchedulingTypeEnum.ASAP }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsEnum(OrderSchedulingTypeEnum, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Object)
], PatchSchedulingInfoDto.prototype, "type", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, description: 'order preparation time in minutes', example: 15 }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchSchedulingInfoDto.prototype, "prepTime", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, description: 'order delay time', example: 4 }),
    IsUndefinable({ always: true }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchSchedulingInfoDto.prototype, "delayTime", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, description: 'order delivery time', example: 30 }),
    IsUndefinable({ always: true }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchSchedulingInfoDto.prototype, "deliveryTime", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, format: 'date-time', description: 'exists when order is delayed', example: '2022-05-05T15:00:00.000+0000' }),
    IsUndefinable({ always: true }),
    IsDate({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Date)
], PatchSchedulingInfoDto.prototype, "selectedDate", void 0);
//# sourceMappingURL=PatchSchedulingInfoDto.js.map